<div>{{ label }} {{ form.get('country')!.value | country }}
  @if (form.get('country'!)?.value !== 'SE' && form.get('tin')?.value) {
    (TIN: {{ form.get('tin')!.value }})
  }
</div>